import { Builder } from "@builder.io/react";
import MessagesList from "components/byTeamTypeMessages/byTeamTypeMessages";
import { toMutable } from "types/common";

const inputs = [
    {
        name: "title",
        type: "text",
        defaultValue:
            "Media Buying Teams use AY to measure the campaign return of investment in real-time and adjust spending.",
        required: true,
    },
    {
        name: "messages",
        type: "list",
        subFields: [
            {
                name: "title",
                type: "text",
                required: true,
            },
        ],
        defaultValue: [
            {
                title: "What was the return of investment on campaign X?",
            },
            {
                title: "Which layout yields the highest revenue per session by user segment?",
            },
        ],
        required: true,
    },
] as const;

const ByTeamTypeMediaBuyingMessages: BFC<typeof inputs> = ({ title, messages }) => {
    return (
        <div className="container">
            <MessagesList title={title} messages={messages} delay={1000} />
        </div>
    );
};

Builder.registerComponent(ByTeamTypeMediaBuyingMessages, {
    name: "byTeamTypeMediaBuyingMessages",
    inputs: toMutable(inputs),
});
